// John Eldhose 20180511
const Languages = (state = [], action) => {
  return state;
};

export default Languages;



// WEBPACK FOOTER //
// ./src/reducers/Languages.js